module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('message-system', {
    attrs: {
      "size": "small"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "columns is-multiline"
  }, [_vm._l((_vm.certificates), function(certificate) {
    return (_vm.certificates.length != 0) ? _c('div', {
      staticClass: "column is-half-tablet is-fullwidth-mobile"
    }, [_c('item-certificate', {
      attrs: {
        "certificate": certificate
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), (_vm.certificates && _vm.certificates.length == 0) ? _c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("\n        Aún no posee certificados\n      ")])]) : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62d7ea98","hasScoped":false}!./src/pages/certificate/template.html
// module id = 415
// module chunks = 1